import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Extraction = lazy(() => import('../pages/extraction/page'));
const Agents = lazy(() => import('../pages/agents/page'));
const Statistics = lazy(() => import('../pages/statistics/page'));
const Applications = lazy(() => import('../pages/applications/page'));
const ApplicationDetail = lazy(() => import('../pages/application-detail/page'));
const ReportDetail = lazy(() => import('../pages/report-detail/page'));
const Repository = lazy(() => import('../pages/repository/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/extraction',
    element: <Extraction />
  },
  {
    path: '/agents',
    element: <Agents />
  },
  {
    path: '/statistics',
    element: <Statistics />
  },
  {
    path: '/applications',
    element: <Applications />,
  },
  {
    path: '/application-detail',
    element: <ApplicationDetail />,
  },
  {
    path: '/report-detail',
    element: <ReportDetail />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
